import type { OfferQuantityButtonType } from "@intelligems/ig-types";

function replaceFunc(source: string, replacements: [string, string][]) {
  let result = source;
  for (const replacement of replacements) {
    result = result
      .replaceAll("#" + replacement[0], replacement[1])
      .replaceAll(
        "#" + replacement[0].toUpperCase(),
        replacement[1].toUpperCase()
      );
  }
  return result;
}

export const getFormattedButton = ({
  discountedUnitPrice,
  newTotalPrice,
  originalTotalPrice,
  originalPricePerItem,
  newPricePerItem,
  productTitle,
  button,
  savedTotalAmount,
  savedAmountPerItem,
  savedPercentage,
}: {
  originalTotalPrice: string | undefined;
  originalPricePerItem: string | undefined;
  newTotalPrice: string | undefined;
  newPricePerItem: string | undefined;
  productTitle: string | undefined;
  discountedUnitPrice: string;
  savedAmountPerItem: string | undefined;
  savedTotalAmount: string | undefined;
  savedPercentage: string | undefined;
  button: OfferQuantityButtonType;
}): OfferQuantityButtonType => {
  const swaps: [string, string][] = [
    ["productTitle", productTitle || ""],
    ["productNewTotalPrice", newTotalPrice || ""],
    ["productNewPricePerItem", newPricePerItem || ""],
    ["productOriginalTotalPrice", originalTotalPrice || ""],
    ["productOriginalPricePerItem", originalPricePerItem || ""],
    ["discountSavedPercentage", savedPercentage || ""],
    ["discountSavedTotal", savedTotalAmount || ""],
    ["discountSavedPerItem", savedAmountPerItem || ""],
  ];
  return {
    ...button,
    buttonTitle: button.buttonTitle
      ? replaceFunc(button.buttonTitle, swaps)
      : null,
    label: button.label ? replaceFunc(button.label, swaps) : null,
    subtitle: button.subtitle ? replaceFunc(button.subtitle, swaps) : null,
    badge: button.badge ? replaceFunc(button.badge, swaps) : null,
    freeGift: button.freeGift
      ? {
          ...button.freeGift,
          freeGiftLabel: button.freeGift.freeGiftLabel
            ? replaceFunc(button.freeGift.freeGiftLabel, swaps)
            : null,
        }
      : undefined,
    freeShipping: button.freeShipping
      ? {
          ...button.freeShipping,
          freeShippingLabel: button.freeShipping.freeShippingLabel
            ? replaceFunc(button.freeShipping.freeShippingLabel, swaps)
            : null,
        }
      : undefined,
  };
};
